<template>
  <div class="container">

    <ProfilePageMenu />
    <!--<h2>Preferences</h2>-->

    <div>
      <form ref="passwordChangeForm">

        <div class="clearfix">

          <div class="c1">
            <h3>Change password</h3>
            <div class="clearfix">
              <fieldset class="half">
                <label for="currentPassword">Current Password</label>
                <input v-model.trim="currentPassword" id="currentPassword" type="password" required minlength="8" autocomplete="current-password" />
              </fieldset>
              <fieldset class="half">
              </fieldset>
            </div>
            <div class="clearfix">
              <fieldset class="half">
                <label for="newPassword1">New Password</label>
                <input v-model.trim="newPassword1" id="newPassword1" type="password" title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}" required minlength="8" autocomplete="new-password" />
              </fieldset>
              <fieldset class="half">
                <label for="newPassword2">Verify New Password</label>
                <input v-model.trim="newPassword2" id="newPassword2" type="password" title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}" required minlength="8" autocomplete="new-password" />
              </fieldset>
              <fieldset>
                The password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters.
              </fieldset>
            </div>
          </div>

          <div class="c2">
          </div>

        </div>

        <div class="clearfix" style="margin-top: 1em;">
          <fieldset>
            <button class="wider" @click.prevent="save" :disabled="currentPassword.length === 0">Change Password</button>
          </fieldset>
        </div>

      </form>

    </div>
  </div>
</template>

<script>
  import ProfilePageMenu from './ProfilePageMenu.vue'

  export default {
    name: 'ProfilePagePreferences',
    components: {
      ProfilePageMenu
    },
    data() {
      return {
        currentPassword: '',
        newPassword1: '',
        newPassword2: ''
      }
    },
    methods: {
      save() {
        if (!this.validatePasswordForm()) {
          return
        }
        this.changePassword()
      },

      validatePasswordForm() {
        document.getElementById('newPassword1').setCustomValidity('')
        if (!this.$refs.passwordChangeForm.checkValidity()) {
          this.$refs.passwordChangeForm.reportValidity()
          return
        }
        if (this.currentPassword.length > 0) {
          if (this.newPassword1 !== this.newPassword2) {
            document.getElementById('newPassword1').setCustomValidity('New passwords do not match')
            this.$refs.passwordChangeForm.reportValidity()
            return false
          }
          if (this.currentPassword === this.newPassword1) {
            document.getElementById('newPassword1').setCustomValidity('New password is the same as current password')
            this.$refs.passwordChangeForm.reportValidity()
            return false
          }
        }
        return true
      },

      changePassword() {
        if (this.currentPassword.length > 0) {
          this.$store.commit('setLoadingSpinner', true)
          const user = this.$store.getters.userPool.getCurrentUser()
          user.getSession(() => {
            user.changePassword(this.currentPassword, this.newPassword1, (err, result) => {
              console.log('changePassword result', JSON.stringify(result))
              if (err) {
                console.error('changePassword err', JSON.stringify(err))
                const code = err.code || ''
                if (code === 'NotAuthorizedException') {
                  this.$notify({ type: 'danger', message: 'Current password was not correct. Password was not changed.' })
                } else if (code === 'InvalidParameterException') {
                  this.$notify({ type: 'danger', message: 'New password does not meet the minimum requirements. Please choose a new one and retry.' })
                } else if (code === 'LimitExceededException') {
                  this.$notify({ type: 'danger', message: 'Too many change password attempts lately. Please retry after some time.' })
                } else {
                  this.$notify({ type: 'danger', message: 'Error during changing password' })
                }
              } else {
                this.$notify({ type: 'info', message: 'Password changed' })
                this.currentPassword = ''
                this.newPassword1 = ''
                this.newPassword2 = ''
              }
              this.$store.commit('setLoadingSpinner', false)
            })
          })
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  h2 { font-weight: 300; }
  label {
    font-weight: 600;
  }

  .clearfix {
    @include clearfix();
  }

  .c1 {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(2/3);
    }
  }
  .c2 {
    text-align: center !important;
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/3);
    }
  }

  .half {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(1/2, $cycle: 2);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ProfilePagePreferences.vue